type ColorContext =
  | 'inherit'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'error'
  | 'info'
  | 'warning';

type ResponseObject = {
  status: string;
  message: any;
};

enum DeviceWidth {
  XS = '425px',
  SM = '768px',
  MD = '1024px',
  LG = '1440px',
  XL = '2560px',
}

enum WorkflowType {
  CREATE = 'create',
  EDIT = 'edit',
}

type BucketType = 'agent' | 'chat_agent' | 'admin' | 'storage';

export {
  type ColorContext,
  type ResponseObject,
  DeviceWidth,
  WorkflowType,
  type BucketType,
};
